<template>
  <div>
    <div id="download-center"
         :class="$store.state.common.ShowContent? 'download-center theme-picker':'theme-picker'"
         popper-class="theme-picker-dropdown">
      <i class="el-icon-download"
         style="font-size: 22px;cursor: pointer;"
         @click="handleDown"></i>
    </div>

    <!--下载中心列表 -->
    <dialog-reset :visible.sync="dialogVisible"
                  top='7vh'
                  height="48vh"
                  width="50%"
                  :zoomShow="false"
                  title="下载中心">
      <avue-crud :option="option"
                 :table-loading="loading"
                 :data="tableData"
                 :page.sync="page"
                 :before-open="beforeOpen"
                 v-model="form"
                 ref="crud"
                 @search-change="searchChange"
                 @search-reset="searchReset"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @refresh-change="refreshChange"
                 @on-load="onLoad">
        <template slot="menu"
                  slot-scope="scope">
          <el-button type="text"
                     size="small"
                     v-if="scope.row.exportResult == 2"
                     @click="downloadFile(scope.row)">下载
          </el-button>
          <el-button type="text"
                     size="small"
                     style="color: #f56c6c"
                     v-if="scope.row.exportResult == 2"
                     @click="toDelete(scope.row)">删除
          </el-button>
        </template>
      </avue-crud>
    </dialog-reset>
  </div>
</template>

<script>
import { getList, remove } from '@/api/down/downloadcenter.js'

export default {
  name: 'topDown',
  data() {
    return {
      tableHeight: 200,
      dialogVisible: false,
      tableData: [],
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        ...this.$store.state.publicOption,
        calcHeight: 30,
        dialogWidth: 1200,
        tip: false,
        searchShow: true,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        dialogClickModal: false,
        menuWidth: 120,
        searchLabelWidth: 70,
        searchMenuSpan: 8,
        searchMenuPosition: 'right',
        column: [
          {
            label: '名称',
            prop: 'exportFileName',
            search: true,
            span: 8,
            searchSpan: 8,
            overHidden: true,
          },
          {
            label: '导出进度',
            prop: 'progress',
            span: 8,
            width: 80,
            search: false,
            overHidden: true,
            formatter: (val, value) => {
              return `${value}%`
            },
          },
          {
            label: '状态',
            prop: 'exportResult',
            span: 8,
            width: 80,
            searchSpan: 8,
            maxlength: 10,
            overHidden: true,
            search: true,
            type: 'select',
            remote: true, //开启远程访问
            formslot: true, //连接规则效验
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=export_result',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '申请时间',
            prop: 'createTime',
            width: 150,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            searchValue: '',
            span: 8,
            searchSpan: 6,
            dateDefault: true,
            type: 'datetime',
            overHidden: true,
            dataType: 'string',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchRange: true,
          },
          {
            label: '完成时间',
            width: 150,
            prop: 'finishTime',
            span: 8,
            hide: false,
            overHidden: true,
          },
          {
            label: '异常原因',
            prop: 'remark',
            span: 8,
            hide: false,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
        ],
      },
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        window.addEventListener('resize', this.handsResize)
        setTimeout(() => {
          this.handsResize()
        }, 600)
      } else window.removeEventListener('resize', this.handsResize, false)
    },
  },
  mounted() { },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁。
    window.removeEventListener('resize', this.handsResize, false)
  },
  methods: {
    handsResize() {
      const dialogHeight =
        document.querySelector('.el-dialog__body').offsetHeight
      const searchHeight =
        this.$refs.crud.$el.querySelector('.avue-crud__search').offsetHeight
      this.$refs.crud.tableHeight = dialogHeight - searchHeight - 70
    },
    handleDown() {
      this.query = {}
      this.dialogVisible = true
    },
    toDelete(row) {
      this.$confirm_danger("删除")
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
    downloadFile(row) {
      // 解决a.download修改fileName不生效解决办法（跨域问题）
      var xml = new XMLHttpRequest()
      xml.open('GET', row.exportUrl, true)
      xml.responseType = 'blob'
      xml.onload = function () {
        var url = window.URL.createObjectURL(xml.response)
        var a = document.createElement('a')
        a.href = url
        a.download = row.exportFileName
        a.click()
      }
      xml.send()
    },
    beforeOpen(done) {
      done()
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      this.loading = true
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      ).then(({ data: { data: resdata } }) => {
        const data = resdata
        this.page.total = data.total
        this.tableData = data.records
        this.loading = false
      })
    },
  },
}
</script>
<style scoped lang="scss">
.theme-picker .el-color-picker__trigger {
  vertical-align: middle;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
  display: none;
}

@-webkit-keyframes sway {
  10% {
    transform: rotate(15deg);
    color: rgb(238, 60, 47);
    font-weight: 700;
  }
  20% {
    transform: rotate(-10deg);
  }
  30% {
    transform: rotate(5deg);
  }
  40% {
    transform: rotate(-5deg);
  }
  50%,
  100% {
    transform: rotate(0deg);
  }
}

.download-center {
  .el-icon-download {
    float: left;
    animation: sway 1.5s 0.15s linear infinite;
    animation: sway 1.5s 0.15s linear infinite;
    animation: sway 1.5s 0.15s linear infinite;
    animation: sway 1.5s 0.15s linear infinite;
  }
}
</style>

